/*
 * @Author: 刘邓
 * @Date: 2022-05-05 13:23:21
 * @LastEditors: 文贝
 * @LastEditTime: 2022-06-22 17:54:23
 * @Description:
 * @FilePath: \ics-chromely\src\lib\Interceptor-manage.ts
 */
import { IInterceptorManage, Interceptor, RejectedFn, ResolvedFn } from '../interfaces/interfaces'

export default class InterceptorManage<T> implements IInterceptorManage<T> {
  // 拦截器
  public interceptors: Array<Interceptor<T> | null> = []

  use(resolved: ResolvedFn<T>, rejected?: RejectedFn): number {
    this.interceptors.push({
      resolved,
      rejected
    })
    return this.interceptors.length - 1
  }

  reject(id: number): void {
    if (this.interceptors[id]) {
      this.interceptors[id] = null
    }
  }
}
